import React, {useEffect, useState} from "react";
import CardForm from "../../../components/form/CardForm";
import {Actions} from "../../../../client/Actions";
import fields from "./MachineModelSelectionFormConfig";
import { useTranslation } from "react-i18next";

const MachineModelSelectionSection = ({
                                          onAddMachine,
                                          setLoader,
                                          filterOutTypes,
                                          access,
                                          onSaved
                                      }) => {


    const [machines, setMachines] = useState()
    const [machineTypes, setMachineTypes] = useState();
    const {t} = useTranslation();

    const loadMachines = () => {
        Actions.get("machine-model", machinesLoaded)
    };

    const loadMachineTypes = () => {
        Actions.get("enums/machineType", setMachineTypes)
    };

    const machinesLoaded = (data) => {

        setMachines(data)

    };
    const customSave = (form, onSaved) => {
        console.log("selected machine: ", form.machine);
        onAddMachine(form);
        onSaved();
    };


    const [dictionaries, setDictionaries] = useState();

    useEffect(() => {
        if (machineTypes && machines) {
            const tmp = {};
            tmp["enums/machineType"] = machineTypes.filter(type => !filterOutTypes.some(mt => mt === type));
            tmp["machineModel"] = machines;
            setDictionaries(tmp);
            console.log("dictionaries", tmp);

        }
    }, [machines, machineTypes]);

    useEffect(loadMachines, [])
    useEffect(loadMachineTypes, [])

    return (
        <>
            {dictionaries && access &&
                <CardForm
                    title={t("common.add_machine")}
                    setLoader={setLoader}
                    fields={fields(t)}
                    width={12}
                    dictionaries={dictionaries}
                    className={"mx-0 px-0"}
                    customSave={customSave}
                    saveButton={t("common.add")}
                    reverseButtons={true}
                    postCancel={onSaved}
                    postSaved={onSaved}
                />
            }
        </>
    );
};

export default MachineModelSelectionSection;
